import React, { useContext, useRef,memo } from 'react';
import { useHistory } from 'react-router-dom';
import { 
  Box, Typography, Card, CardContent, CardActionArea, Button, 
  CardMedia, CardActions, Chip, Grid , Stack
} from '@mui/material';
import AuthContext from "flexbiz-core/components/auth/Context";
import DataListManager from 'flexbiz-core/components/DataListManager';

import BrokerWidget from "./broker/BrokerTeaserWidget";

import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SquareFootOutlinedIcon from '@mui/icons-material/SquareFootOutlined';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'; // Icon Người đăng
import AccessTimeIcon from '@mui/icons-material/AccessTime';       // Icon Thời gian
import StyleIcon from '@mui/icons-material/Style';                 // Icon Đơn giá
import SecureImage from 'flexbiz-core/components/SecureImage';


import CampaignIcon from '@mui/icons-material/Campaign';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

 // ================= 1. HÀM TIỆN ÍCH =================
  const formatPrice = (price) => {
    if (!price || isNaN(price)) return 'Thỏa thuận';
    if (price >= 1000000000) return (price / 1000000000).toLocaleString('vi-VN', { maximumFractionDigits: 2 }) + ' Tỷ';
    if (price >= 1000000) return (price / 1000000).toLocaleString('vi-VN', { maximumFractionDigits: 0 }) + ' Triệu';
    return new Intl.NumberFormat('vi-VN').format(price) + ' đ';
  };

  const formatDateTime = (isoString) => {
    if (!isoString) return '---';
    return new Date(isoString).toLocaleString('vi-VN', { 
      hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric' 
    });
  };


// 1. TÁCH THẺ BẤT ĐỘNG SẢN THÀNH MỘT COMPONENT RIÊNG BÊN NGOÀI
const RealEstateCard = memo(({ item, index, onDetail, onToggleWish, getImageUrl, context }) => {
  const isWished = !!item.id_wish;
  const src_image = getImageUrl(item);
  
  return (
    // 1. Ép Card cao 100% lấp đầy Grid Cell, dùng Flexbox dọc để đẩy content
    <Card sx={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column', 
      //mb: 2.5, 
      borderRadius: 4, 
      boxShadow: '0 4px 20px rgba(0,0,0,0.06)', 
      border: 'none', 
      overflow: 'hidden',
      transition: 'transform 0.2s ease-in-out, box-shadow 0.2s',
      '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 24px rgba(0,0,0,0.1)' }
    }}>
      
      {/* 2. Ép CardActionArea giãn nở lấp đầy phần trên của Card */}
      <CardActionArea 
        onClick={() => onDetail(item)} 
        sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
      >
        
        {/* 3. KHUNG ẢNH: Khóa chết chiều cao (VD: 200px) và rộng 100% */}
        <Box sx={{ position: 'relative', width: '100%', height: 200, flexShrink: 0, bgcolor: '#f5f5f5' }}>
          {!!src_image ? (
            <SecureImage
              alt={item.ten_nd}
              effect="blur" 
              src={src_image}
              width="100%"
              height="100%"
              // objectFit: 'cover' sẽ tự động cắt cúp ảnh vừa vặn khung 200px mà không bị méo
              style={{ objectFit: 'cover', display: 'block', width: '100%', height: '100%' }} 
            />
          ) : (
            // Fallback nếu không có ảnh
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: 'text.secondary' }}>
              <Typography variant="caption">Không có ảnh</Typography>
            </Box>
          )}
          
          {/* THẺ GIÁ */}
          <Chip 
            label={formatPrice(item.gia_ban)} 
            sx={{ position: 'absolute', bottom: 12, left: 12, bgcolor: 'rgba(0, 0, 0, 0.75)', color: '#fff', fontWeight: '900', fontSize: '1rem', height: 32, backdropFilter: 'blur(4px)' }} 
          />
          
          {/* NHÓM BĐS (VIP/CHÍNH CHỦ) */}
          {item.ten_nhom && (
            <Chip label={item.ten_nhom} size="small" sx={{ position: 'absolute', top: 12, left: 12, bgcolor: '#ff3b30', color: 'white', fontWeight: 'bold' }} />
          )}

          {/* PHÂN LOẠI BĐS */}
          {item.phan_loai && (
            <Chip label={item.phan_loai} size="small" sx={{ position: 'absolute', top: 12, right: 12, bgcolor: 'rgba(0,0,0,0.6)', color: 'white', fontWeight: 'bold' }} />
          )}
        </Box>

        {/* 4. CONTENT: Ép chiếm nốt phần còn lại của CardActionArea */}
        <CardContent sx={{ p: '16px !important', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          
          <Box sx={{ flexGrow: 1 }}>
            {/* TIÊU ĐỀ & MÃ BĐS */}
            <Typography variant="subtitle1" fontWeight="bold" sx={{ lineHeight: 1.3, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
              {item.ten_nd || 'Bất động sản chưa cập nhật tên'}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1, fontWeight: 'bold' }}>
              Mã: {item.ma_nd || '---'}
            </Typography>
            
            {/* VỊ TRÍ */}
            <Box sx={{ display: 'flex', alignItems: 'flex-start', color: 'text.secondary', mb: 1.5 }}>
              <LocationOnOutlinedIcon sx={{ fontSize: 16, mr: 0.5, mt: 0.2 }} />
              <Typography variant="body2" noWrap>{item.tinh_thanh || 'Chưa cập nhật vị trí'}</Typography>
            </Box>

            {/* BẢNG THÔNG SỐ */}
            <Grid container spacing={1} sx={{ bgcolor: '#f8f9fa', p: 1.5, borderRadius: 2, mb: 1.5 }}>
              <Grid size={{xs:6}}>
                <Box sx={{ display: 'flex', alignItems: 'center', color: '#1c1c1e' }}>
                  <SquareFootOutlinedIcon sx={{ fontSize: 18, mr: 0.5, color: '#8e8e93' }} />
                  <Typography variant="body2" fontWeight="600">{item.dien_tich ? `${item.dien_tich} m²` : '---'}</Typography>
                </Box>
              </Grid>
              
              <Grid size={{xs:6}}>
                <Box sx={{ display: 'flex', alignItems: 'center', color: '#1c1c1e' }}>
                  <AspectRatioIcon sx={{ fontSize: 16, mr: 0.5, color: '#8e8e93' }} />
                  <Typography variant="body2" fontWeight="600" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {item.chieu_ngang && item.chieu_dai ? `${item.chieu_ngang}m x ${item.chieu_dai}m` : (item.chieu_ngang ? `Ngang ${item.chieu_ngang}m` : '---')}
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{xs:12}} sx={{ mt: 0.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', color: '#1c1c1e' }}>
                  <StyleIcon sx={{ fontSize: 16, mr: 0.5, color: '#8e8e93' }} />
                  <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>Đơn giá:</Typography>
                  <Typography variant="body2" fontWeight="bold" color="#ff9500">
                    {item.gia_ban_m2 ? `${new Intl.NumberFormat('vi-VN').format(item.gia_ban_m2)} đ/m²` : 'Thỏa thuận'}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* 5. THÔNG TIN ĐÁY (Đẩy sát xuống đáy Content) */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 0.5, mt: 'auto', pt: 1, borderTop: '1px solid #f0f0f0' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
              <PersonOutlineIcon sx={{ fontSize: 16, mr: 0.5 }} />
              <Typography variant="caption" noWrap sx={{ maxWidth: 140, fontWeight: 500 }}>{item.name_user_created || 'Ẩn danh'}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
              <AccessTimeIcon sx={{ fontSize: 14, mr: 0.5 }} />
              <Typography variant="caption">{formatDateTime(item.date_created)}</Typography>
            </Box>
          </Box>

        </CardContent>
      </CardActionArea>

      {/* 6. NÚT TƯƠNG TÁC (Nằm ngoài CardActionArea để tránh click nhầm) */}
      <CardActions sx={{ px: 2, pb: 2, pt: 1, justifyContent: 'space-between', gap: 1, mt: 'auto' }}>
        <Button 
          variant={isWished ? "contained" : "outlined"} 
          startIcon={isWished ? <FavoriteIcon /> : <FavoriteBorderIcon />} 
          onClick={(e) => onToggleWish(e, item)} 
          sx={{ flex: 1, borderRadius: 3, textTransform: 'none', fontWeight: 'bold', color: isWished ? 'white' : '#ff3b30', bgcolor: isWished ? '#ff3b30' : 'transparent', borderColor: isWished ? 'transparent' : 'rgba(255,59,48,0.3)', boxShadow: 'none', '&:hover': { bgcolor: isWished ? '#d32f2f' : 'rgba(255,59,48,0.04)', boxShadow: 'none' } }}
        >
          {isWished ? 'Đã lưu' : 'Quan tâm'}
        </Button>

        <Button 
          variant="contained" startIcon={<PhoneInTalkIcon />} component="a" 
          href={`tel:${item.dien_thoai || context.appInfo?.phone}`} 
          onClick={(e) => e.stopPropagation()} 
          sx={{ flex: 1, borderRadius: 3, textTransform: 'none', fontWeight: 'bold', bgcolor: '#34c759', color: 'white', boxShadow: 'none' }}
        >
          Gọi ngay
        </Button>
      </CardActions>
    </Card>
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.item._id === nextProps.item._id &&
    prevProps.item.id_wish === nextProps.item.id_wish &&
    prevProps.item.trang_thai === nextProps.item.trang_thai
  );
});

export default function DashboardPage() {
  const history = useHistory();
  const context = useContext(AuthContext);
  const { userInfo } = context;

  const managerRef = useRef(null);

 
  const getImageUrl = (item) => {
    const imagePath = item.picture || item.hinh_anh;
    if (!imagePath || !context?.config?.server_url || !context?.config?.public_token) return null;
    const slash = imagePath.startsWith('/') ? '' : '/';
    return `${context.config.server_url}${slash}${imagePath}?access_token=${context.config.public_token}`;
  };

  // ================= 2. XỬ LÝ SỰ KIỆN CLICK =================
  const handleViewDetail = (item) => {
    const group_name = (context.appInfo?.par?.group?.group_name || "").toLowerCase();
    let page = item.la_du_an_chu_dau_tu && group_name.indexOf("môi giới") >= 0 
      ? `nhadat_agent_moigioi` 
      : `nhadat_agent`;
    context.objectView(page, item._id);
  };

  const handleToggleWish = async (e, item) => {
    e.stopPropagation(); 
    try {
      await context.signin();
      let updatedItem = { ...item }; 
      if (item.id_wish) {
        await context.apis.asyncDeleteList(context.userInfo.token, "ecomwishlist", item.id_wish);
        updatedItem.wish = false;
        updatedItem.id_wish = null;
      } else {
        let rs = await context.apis.asyncPostList(context.userInfo.token, "ecomwishlist", {
          user: context.userInfo.email,
          ma_vt: item.ma_nd
        },{replace_if_exists:true});
        updatedItem.wish = true;
        updatedItem.id_wish = Array.isArray(rs) ? rs[0]._id : rs._id;
      }
      if (managerRef.current) managerRef.current.updateLocalItem(updatedItem);
    } catch (err) {
      context.alert(err.error || err.message || err, null, "red");
    }
  };

  // ================= 3. BANNER QUẢNG CÁO =================
  function QC() {
    const phone = context.defaultAppInfo?.phone;
    return (
      <Card 
        elevation={0} 
        sx={{
          ...(context.config.cardProps?.style || {}),
          mt: 0, 
          borderRadius: 4,
          position: 'relative',
          overflow: 'hidden',
          background: 'linear-gradient(135deg, #059669 0%, #10B981 100%)',
          color: '#ffffff',
          boxShadow: '0 4px 12px rgba(16, 185, 129, 0.2)',
        }}
      >
        {/* Họa tiết mờ chìm (Watermark) */}
        <Box sx={{ position: 'absolute', top: -30, right: -20, opacity: 0.1, transform: 'rotate(15deg)', pointerEvents: 'none' }}>
          <CampaignIcon sx={{ fontSize: 140 }} />
        </Box>

        <CardContent sx={{ p: { xs: 2.5, sm: 3 }, position: 'relative', zIndex: 1 }}>
          
          {/* ================= KHU VỰC TEXT GIỚI THIỆU ================= */}
          <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
            <CampaignIcon sx={{ mr: 1.5, fontSize: 36, color: '#fef3c7', mt: -0.5 }} />
            <Box>
              <Typography variant="h6" fontWeight="800" sx={{ textTransform: 'uppercase', letterSpacing: 0.5, lineHeight: 1.2, mb: 0.5 }}>
                {context.apis.getLabel("Nhận thu mua BĐS")}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.95, fontSize: '0.9rem', lineHeight: 1.5, maxWidth: '95%' }}>
                {context.apis.getLabel("Mua nhanh, thanh toán ngay, mua tất cả các loại bất động sản kể cả đất bị quy hoạch...")}
              </Typography>
            </Box>
          </Box>

          {/* ================= PHÂN CHIA 2 KHU VỰC RÕ RÀNG ================= */}
          <Box sx={{ mt: 3, pt: 2.5, borderTop: '1px solid rgba(255,255,255,0.2)' }}>
            <Grid container spacing={2}>
              
              {/* KHU VỰC 1: LIÊN HỆ TƯ VẤN */}
              {phone && (
                <Grid size={{xs:12,sm:6}}>
                  <Typography variant="caption" sx={{ opacity: 0.8, display: 'block', mb: 1.5, fontWeight: 'bold', letterSpacing: 0.5 }}>
                    {context.apis.getLabel("LIÊN HỆ TRỰC TIẾP")}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1.5 }}>
                    {/* Chuyển Box thành Button để đồng bộ kích thước Medium */}
                    <Button 
                      fullWidth
                      component="a" 
                      href={`tel:${phone}`}
                      variant="contained"
                      sx={{ 
                        bgcolor: 'rgba(255,255,255,0.15)', 
                        color: 'white', 
                        boxShadow: 'none',
                        '&:hover': { bgcolor: 'rgba(255,255,255,0.25)', boxShadow: 'none' } 
                      }}
                    >
                      <img src='/images/phone.png' alt="phone" style={{ width: 18, height: 18, marginRight: 8, objectFit: 'contain' }} /> 
                      {phone}
                    </Button>

                    <Button 
                      fullWidth
                      component="a" 
                      href={`https://zalo.me/${phone}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      variant="contained"
                      sx={{ 
                        bgcolor: 'rgba(255,255,255,0.15)', 
                        color: 'white', 
                        boxShadow: 'none',
                        '&:hover': { bgcolor: 'rgba(255,255,255,0.25)', boxShadow: 'none' } 
                      }}
                    >
                      <img src='/images/zalo.png' alt="zalo" style={{ width: 18, height: 18, marginRight: 8, objectFit: 'contain' }} /> 
                      Zalo
                    </Button>
                  </Box>
                </Grid>
              )}

              {/* KHU VỰC 2: GIAO DỊCH NHANH */}
              <Grid size={{xs:12,sm:phone?6:12}}>
                <Typography variant="caption" sx={{ opacity: 0.8, display: 'block', mb: 1.5, fontWeight: 'bold', letterSpacing: 0.5 }}>
                  {context.apis.getLabel("GỬI YÊU CẦU")}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1.5 }}>
                  <Button 
                    fullWidth
                    variant="contained" 
                    // Bỏ size="small" để lấy size mặc định (Medium) của hệ thống
                    startIcon={<SellOutlinedIcon />}
                    onClick={() => history.push('/quickinput/nhadat_ban?nh_nd=BANCHOCTY')}
                    sx={{ 
                      bgcolor: 'white', 
                      color: '#059669', 
                      boxShadow: 'none', 
                      '&:hover': { bgcolor: '#f8fafc', boxShadow: 'none' } 
                    }}
                  >
                    Đăng bán
                  </Button>
                  
                  <Button 
                    fullWidth
                    variant="contained" 
                    color="warning" 
                    // Bỏ size="small"
                    startIcon={<ShoppingCartOutlinedIcon />}
                    onClick={() => history.push('/quickinput/nhadat_mua?nh_nd=NHUCAU')}
                    sx={{ boxShadow: 'none' }}
                  >
                    Đăng mua
                  </Button>
                </Box>
              </Grid>

            </Grid>
          </Box>

        </CardContent>
      </Card>
    );
  }

  const renderDashboardWidgets = () => (
    <Box sx={{ mb: 2 }}>
      {userInfo?.name && userInfo?.email!="public" && <Box sx={{ mb: 2, mt: 1 }}>
        <Typography variant="body2" color="text.secondary">Xin chào,</Typography>
        <Typography variant="h5" fontWeight="900" sx={{ color: '#1c1c1e' }}>
          {userInfo?.name || "Khách hàng"}
        </Typography>
      </Box>}
      <Grid container spacing={2}>
        <Grid  size={{xs:12,sm:6}}>
          <QC />
        </Grid>
        <Grid   size={{xs:12,sm:6}}>
          <BrokerWidget />
        </Grid>
      </Grid>
      
    </Box>
  );

  // ================= 4. RENDER PROPERTY CARD (NÂNG CẤP) =================
  const renderRealEstateCard = (item, index, onEdit, onDelete) => {
    return (
      <RealEstateCard 
        key={item._id}
        item={item}
        index={index}
        onDetail={() => handleViewDetail(item)}
        onToggleWish={(e) => handleToggleWish(e, item)}
        getImageUrl={getImageUrl}
        context={context}
      />
    );
  };

  // ================= 5. CẤU HÌNH DATA LIST (CẬP NHẬT MỚI) =================
  const nhadatFields = [
    { field: "ten_nd", label: "Tên bất động sản", type: "String", isTitle: true },
    { field: "ma_nd", label: "Mã bất động sản", type: "String", isSubTitle: true },

    { field: "phan_loai", label: "Phân loại", type: "Select",api:"phanloainhadat",apiMapping:{value:"ten_phan_loai",label:"ten_phan_loai"} },

    { field: "nh_nd", label: "Kiểu BĐS", type: "Select", hideInList: true,api:"nhomnhadat",apiMapping:{value:"ma_nhom",label:"ten_nhom"} },
    { field: "ten_nhom", label: "Nhóm BĐS", type: "String",searchable:false },

    { field: "gia_ban", label: "Giá bán", type: "Number" },
    { field: "gia_ban_m2", label: "Giá bán/m2", type: "Number" },
    { field: "chieu_ngang", label: "Mặt tiền", type: "Number" },
    { field: "chieu_dai", label: "Chiều dài (sâu)", type: "Number" },
    { field: "dien_tich", label: "Diện tích", type: "Number" },
    { field: "picture", label: "Hình đại diện", type: "String",searchable:false },
    { field: "tinh_thanh", label: "Tỉnh thành", type: "Autocomplete",api:"tinhthanh",apiMapping:{value:"ten_tinh_thanh",label:"ten_tinh_thanh"}  },
    { field: "dien_thoai", label: "Điện thoại", type: "String",searchable:false },

    { field: "user_created", label: "Người đăng", type: "String", hideInForm: true,searchable:false },
    { field: "name_user_created", label: "Người đăng", type: "String",searchable:false },

    { field: "date_created", label: "Thời gian đăng", type: "DateTime",searchable:false },
    { field: "wish", label: "wish", type: "String", hideInList: true, hideInForm: true,searchable:false },
    { field: "id_wish", label: "ID Wish", type: "String", hideInList: true, hideInForm: true,searchable:false },
    { field: "id_app", label: "Công ty", type: "String", hideInList: true, hideInForm: true,searchable:false }
  ];

  const bdsSortOptions = [
    { label: "Mới nhất", sort: { date_created: -1 } },
    { label: "Giá: Thấp đến cao", sort: { gia_ban: 1 } },
    { label: "Giá: Cao xuống thấp", sort: { gia_ban: -1 } },
    { label: "Diện tích: Nhỏ đến lớn", sort: { dien_tich: 1 } },
    { label: "Diện tích: Lớn xuống nhỏ", sort: { dien_tich: -1 } }
  ];

  return (
    <DataListManager
        ref={managerRef}
        title="Khám phá bất động sản"
        code="nhadat"
        fields={nhadatFields}
        condition={{ trang_thai: "5", la_du_an_chu_dau_tu: false }}
        
        hideHeader={true}
        sortOptions={bdsSortOptions}
        
        banners={renderDashboardWidgets()}
        transformData={(rawDataArray) => {
          return rawDataArray.map(item => ({
            ...item,
            dien_thoai: item.dien_thoai_chu_so_huu || context.appInfo?.phone
          }));
        }}
        listContainerSx={{ pb: 9, px: 2 }}
        containerSx={{ height: '100%' }}
        actionBarPosition="top"
        quickFilterConfig={{
          field: "nh_nd",
          api: "nhomnhadat", 
          apiMapping: { value: "ma_nhom", label: "ten_nhom" }
        }}
        canAdd={false}
        canEdit={false}
        canDelete={false}
        renderItem={renderRealEstateCard}
      />
  );
}